import React from 'react';

const Gallery = () => {
  const galleryImages = [
    {
      url: 'https://images.pexels.com/photos/6235231/pexels-photo-6235231.jpeg',
      alt: 'Veterinarian examining dog on examination table'
    },
    {
      url: 'https://images.pexels.com/photos/6131543/pexels-photo-6131543.jpeg',
      alt: 'Veterinarian caring for cat with mask'
    },
    {
      url: 'https://images.pexels.com/photos/7469229/pexels-photo-7469229.jpeg',
      alt: 'Professional examination of dog'
    },
    {
      url: 'https://images.pexels.com/photos/6131540/pexels-photo-6131540.jpeg',
      alt: 'Veterinarian treating cat in clinical setting'
    },
    {
      url: 'https://images.unsplash.com/photo-1710322928695-c7fb49886cb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx2ZXRlcmluYXJpYW4lMjBjYXR8ZW58MHx8fHwxNzY3MTE1NzY0fDA&ixlib=rb-4.1.0&q=85',
      alt: 'Cat examination showing professional care'
    },
    {
      url: 'https://images.unsplash.com/photo-1581888227599-779811939961?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxwZXQlMjBjYXJlfGVufDB8fHx8MTc2NzA0MTQyM3ww&ixlib=rb-4.1.0&q=85',
      alt: 'Happy dog resting on couch after recovery'
    },
    {
      url: 'https://images.unsplash.com/photo-1415369629372-26f2fe60c467?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHxwZXQlMjBjYXJlfGVufDB8fHx8MTc2NzA0MTQyM3ww&ixlib=rb-4.1.0&q=85',
      alt: 'Cat trusting human hand showing bonding'
    },
    {
      url: 'https://images.pexels.com/photos/1981111/pexels-photo-1981111.jpeg',
      alt: 'Compassionate care for small kitten'
    }
  ];

  return (
    <div style={{ paddingTop: '5rem' }}>
      {/* Gallery Hero */}
      <section className="container" style={{ marginTop: '3rem', marginBottom: '4rem', textAlign: 'center' }}>
        <h1 className="heading-1" style={{ marginBottom: '1rem' }}>
          Our Gallery
        </h1>
        <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto', color: 'var(--text-secondary)' }}>
          A glimpse into our compassionate veterinary care - from routine checkups to life-saving treatments.
        </p>
      </section>

      {/* Gallery Grid */}
      <section className="container" style={{ marginBottom: '4rem' }}>
        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div key={index} className="gallery-item">
              <img src={image.url} alt={image.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Info */}
      <section style={{ background: 'var(--bg-section)', padding: '4rem 1.5rem' }}>
        <div className="container" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            Capturing Moments of Care
          </h2>
          <p className="body-large" style={{ color: 'var(--text-body)', marginBottom: '1.5rem' }}>
            These images represent the heart of what we do at Teja's Pet Care - providing compassionate, 
            expert veterinary care to every animal that comes through our doors. From routine wellness checks 
            to critical emergency treatments, we approach each case with dedication and love.
          </p>
          <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
            Every pet has a story, and we're honored to be part of their journey to health and happiness.
          </p>
        </div>
      </section>

      {/* Visit CTA */}
      <section className="container" style={{ marginTop: '4rem', marginBottom: '4rem', textAlign: 'center' }}>
        <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
          Visit Us in Person
        </h2>
        <p className="body-large" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
          See our facilities and meet our caring team. We're open 24/7 for your convenience.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="tel:+918199981444" className="btn-primary">
            Call Us Now
          </a>
          <a 
            href="https://www.google.com/maps/dir//GGV5+RJ+Bhimavaram,+Andhra+Pradesh/@16.544439,81.509358,16z?entry=ttu" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-secondary"
          >
            Get Directions
          </a>
        </div>
      </section>
    </div>
  );
};

export default Gallery;